import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pengguna: {
      nama: '',
      emel: '',
      nokp: '',
      peranan: '',
      id_user: '',
      valid: false,
    }
  },

  mutations: {
    setNama(state, nama) {
      state.pengguna.nama = nama;
    },
    setPeranan(state, status_entitle) {
      state.pengguna.peranan = status_entitle;
    },
    saveToken(state, id) {
      state.pengguna.id_user = id;
      state.pengguna.valid = true;
    },
    logoff(state) {
      state.pengguna.nama = '';
      state.pengguna.peranan = '';
      state.pengguna.id_user = '';
      state.pengguna.buidagensi = '';
      state.pengguna.icno = '';
      state.pengguna.valid = false;
      localStorage.clear();
      localStorage.setItem('user.valid', false);
    }

  },
  actions: {
    updateNama({ commit }, nama) {
      commit('setNama', nama);
    },
    updatePeranan({ commit }, status_entitle) {
      commit('setPeranan', status_entitle);
    },
    hasPermission({ state }) {
      return state.Pengguna.valid;
    },
  }
})
